// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/workload_federation/v1/workload_federation.proto" (package "c1.api.workload_federation.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { WorkloadFederationService } from "./workload_federation";
import type { WorkloadFederationServiceSearchTrustsResponse } from "./workload_federation";
import type { WorkloadFederationServiceSearchTrustsRequest } from "./workload_federation";
import type { WorkloadFederationServiceTestCELResponse } from "./workload_federation";
import type { WorkloadFederationServiceTestCELRequest } from "./workload_federation";
import type { WorkloadFederationServiceTestTokenResponse } from "./workload_federation";
import type { WorkloadFederationServiceTestTokenRequest } from "./workload_federation";
import type { WorkloadFederationServiceListTrustsResponse } from "./workload_federation";
import type { WorkloadFederationServiceListTrustsRequest } from "./workload_federation";
import type { WorkloadFederationServiceDeleteTrustResponse } from "./workload_federation";
import type { WorkloadFederationServiceDeleteTrustRequest } from "./workload_federation";
import type { WorkloadFederationServiceUpdateTrustResponse } from "./workload_federation";
import type { WorkloadFederationServiceUpdateTrustRequest } from "./workload_federation";
import type { WorkloadFederationServiceGetTrustResponse } from "./workload_federation";
import type { WorkloadFederationServiceGetTrustRequest } from "./workload_federation";
import type { WorkloadFederationServiceCreateTrustResponse } from "./workload_federation";
import type { WorkloadFederationServiceCreateTrustRequest } from "./workload_federation";
import type { WorkloadFederationServiceListProvidersResponse } from "./workload_federation";
import type { WorkloadFederationServiceListProvidersRequest } from "./workload_federation";
import type { WorkloadFederationServiceDeleteProviderResponse } from "./workload_federation";
import type { WorkloadFederationServiceDeleteProviderRequest } from "./workload_federation";
import type { WorkloadFederationServiceUpdateProviderResponse } from "./workload_federation";
import type { WorkloadFederationServiceUpdateProviderRequest } from "./workload_federation";
import type { WorkloadFederationServiceGetProviderResponse } from "./workload_federation";
import type { WorkloadFederationServiceGetProviderRequest } from "./workload_federation";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { WorkloadFederationServiceCreateProviderResponse } from "./workload_federation";
import type { WorkloadFederationServiceCreateProviderRequest } from "./workload_federation";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * WorkloadFederationService provides CRUD operations for workload federation
 * providers (tenant-level OIDC issuer registrations) and trusts (per-SP
 * claim-matching policies).
 *
 * --- Provider CRUD (admin-only) ---
 *
 * @generated from protobuf service c1.api.workload_federation.v1.WorkloadFederationService
 */
export interface IWorkloadFederationServiceClient {
    /**
     * CreateProvider registers a new external OIDC issuer for the tenant.
     * Validates the issuer URL via OIDC discovery synchronously.
     *
     * @generated from protobuf rpc: CreateProvider
     */
    createProvider(input: WorkloadFederationServiceCreateProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceCreateProviderRequest, WorkloadFederationServiceCreateProviderResponse>;
    /**
     * GetProvider returns a provider by ID.
     *
     * @generated from protobuf rpc: GetProvider
     */
    getProvider(input: WorkloadFederationServiceGetProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceGetProviderRequest, WorkloadFederationServiceGetProviderResponse>;
    /**
     * UpdateProvider updates a provider's mutable fields (display_name, description, disabled).
     * The issuer_url is immutable after creation.
     *
     * @generated from protobuf rpc: UpdateProvider
     */
    updateProvider(input: WorkloadFederationServiceUpdateProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceUpdateProviderRequest, WorkloadFederationServiceUpdateProviderResponse>;
    /**
     * DeleteProvider deletes a provider. Fails if active trusts reference it.
     *
     * @generated from protobuf rpc: DeleteProvider
     */
    deleteProvider(input: WorkloadFederationServiceDeleteProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceDeleteProviderRequest, WorkloadFederationServiceDeleteProviderResponse>;
    /**
     * ListProviders lists all providers for the tenant.
     *
     * @generated from protobuf rpc: ListProviders
     */
    listProviders(input: WorkloadFederationServiceListProvidersRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceListProvidersRequest, WorkloadFederationServiceListProvidersResponse>;
    // --- Trust CRUD (SP-scoped) ---

    /**
     * CreateTrust creates a trust policy for a service principal.
     * Validates the CEL condition_expression at creation time.
     *
     * @generated from protobuf rpc: CreateTrust
     */
    createTrust(input: WorkloadFederationServiceCreateTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceCreateTrustRequest, WorkloadFederationServiceCreateTrustResponse>;
    /**
     * GetTrust returns a trust by ID for a service principal.
     *
     * @generated from protobuf rpc: GetTrust
     */
    getTrust(input: WorkloadFederationServiceGetTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceGetTrustRequest, WorkloadFederationServiceGetTrustResponse>;
    /**
     * UpdateTrust updates a trust's mutable fields. The provider_id is immutable.
     *
     * @generated from protobuf rpc: UpdateTrust
     */
    updateTrust(input: WorkloadFederationServiceUpdateTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceUpdateTrustRequest, WorkloadFederationServiceUpdateTrustResponse>;
    /**
     * DeleteTrust deletes a trust for a service principal.
     *
     * @generated from protobuf rpc: DeleteTrust
     */
    deleteTrust(input: WorkloadFederationServiceDeleteTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceDeleteTrustRequest, WorkloadFederationServiceDeleteTrustResponse>;
    /**
     * ListTrusts lists trusts for a service principal.
     *
     * @generated from protobuf rpc: ListTrusts
     */
    listTrusts(input: WorkloadFederationServiceListTrustsRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceListTrustsRequest, WorkloadFederationServiceListTrustsResponse>;
    // --- Testing RPCs ---

    /**
     * TestToken validates a JWT against a specific trust's configuration without
     * issuing an access token. Returns per-step validation results for debugging.
     *
     * @generated from protobuf rpc: TestToken
     */
    testToken(input: WorkloadFederationServiceTestTokenRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceTestTokenRequest, WorkloadFederationServiceTestTokenResponse>;
    /**
     * TestCEL evaluates a CEL expression against provided claims without
     * requiring a JWT, provider, or trust. Used for expression authoring.
     *
     * @generated from protobuf rpc: TestCEL
     */
    testCEL(input: WorkloadFederationServiceTestCELRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceTestCELRequest, WorkloadFederationServiceTestCELResponse>;
    /**
     * SearchTrusts searches trusts across all service principals with optional filters.
     * Used by the admin providers page to list trusts referencing a provider.
     *
     * @generated from protobuf rpc: SearchTrusts
     */
    searchTrusts(input: WorkloadFederationServiceSearchTrustsRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceSearchTrustsRequest, WorkloadFederationServiceSearchTrustsResponse>;
}
/**
 * WorkloadFederationService provides CRUD operations for workload federation
 * providers (tenant-level OIDC issuer registrations) and trusts (per-SP
 * claim-matching policies).
 *
 * --- Provider CRUD (admin-only) ---
 *
 * @generated from protobuf service c1.api.workload_federation.v1.WorkloadFederationService
 */
export class WorkloadFederationServiceClient implements IWorkloadFederationServiceClient, ServiceInfo {
    typeName = WorkloadFederationService.typeName;
    methods = WorkloadFederationService.methods;
    options = WorkloadFederationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * CreateProvider registers a new external OIDC issuer for the tenant.
     * Validates the issuer URL via OIDC discovery synchronously.
     *
     * @generated from protobuf rpc: CreateProvider
     */
    createProvider(input: WorkloadFederationServiceCreateProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceCreateProviderRequest, WorkloadFederationServiceCreateProviderResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceCreateProviderRequest, WorkloadFederationServiceCreateProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetProvider returns a provider by ID.
     *
     * @generated from protobuf rpc: GetProvider
     */
    getProvider(input: WorkloadFederationServiceGetProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceGetProviderRequest, WorkloadFederationServiceGetProviderResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceGetProviderRequest, WorkloadFederationServiceGetProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateProvider updates a provider's mutable fields (display_name, description, disabled).
     * The issuer_url is immutable after creation.
     *
     * @generated from protobuf rpc: UpdateProvider
     */
    updateProvider(input: WorkloadFederationServiceUpdateProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceUpdateProviderRequest, WorkloadFederationServiceUpdateProviderResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceUpdateProviderRequest, WorkloadFederationServiceUpdateProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteProvider deletes a provider. Fails if active trusts reference it.
     *
     * @generated from protobuf rpc: DeleteProvider
     */
    deleteProvider(input: WorkloadFederationServiceDeleteProviderRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceDeleteProviderRequest, WorkloadFederationServiceDeleteProviderResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceDeleteProviderRequest, WorkloadFederationServiceDeleteProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListProviders lists all providers for the tenant.
     *
     * @generated from protobuf rpc: ListProviders
     */
    listProviders(input: WorkloadFederationServiceListProvidersRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceListProvidersRequest, WorkloadFederationServiceListProvidersResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceListProvidersRequest, WorkloadFederationServiceListProvidersResponse>("unary", this._transport, method, opt, input);
    }
    // --- Trust CRUD (SP-scoped) ---

    /**
     * CreateTrust creates a trust policy for a service principal.
     * Validates the CEL condition_expression at creation time.
     *
     * @generated from protobuf rpc: CreateTrust
     */
    createTrust(input: WorkloadFederationServiceCreateTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceCreateTrustRequest, WorkloadFederationServiceCreateTrustResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceCreateTrustRequest, WorkloadFederationServiceCreateTrustResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetTrust returns a trust by ID for a service principal.
     *
     * @generated from protobuf rpc: GetTrust
     */
    getTrust(input: WorkloadFederationServiceGetTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceGetTrustRequest, WorkloadFederationServiceGetTrustResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceGetTrustRequest, WorkloadFederationServiceGetTrustResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateTrust updates a trust's mutable fields. The provider_id is immutable.
     *
     * @generated from protobuf rpc: UpdateTrust
     */
    updateTrust(input: WorkloadFederationServiceUpdateTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceUpdateTrustRequest, WorkloadFederationServiceUpdateTrustResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceUpdateTrustRequest, WorkloadFederationServiceUpdateTrustResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteTrust deletes a trust for a service principal.
     *
     * @generated from protobuf rpc: DeleteTrust
     */
    deleteTrust(input: WorkloadFederationServiceDeleteTrustRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceDeleteTrustRequest, WorkloadFederationServiceDeleteTrustResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceDeleteTrustRequest, WorkloadFederationServiceDeleteTrustResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListTrusts lists trusts for a service principal.
     *
     * @generated from protobuf rpc: ListTrusts
     */
    listTrusts(input: WorkloadFederationServiceListTrustsRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceListTrustsRequest, WorkloadFederationServiceListTrustsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceListTrustsRequest, WorkloadFederationServiceListTrustsResponse>("unary", this._transport, method, opt, input);
    }
    // --- Testing RPCs ---

    /**
     * TestToken validates a JWT against a specific trust's configuration without
     * issuing an access token. Returns per-step validation results for debugging.
     *
     * @generated from protobuf rpc: TestToken
     */
    testToken(input: WorkloadFederationServiceTestTokenRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceTestTokenRequest, WorkloadFederationServiceTestTokenResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceTestTokenRequest, WorkloadFederationServiceTestTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * TestCEL evaluates a CEL expression against provided claims without
     * requiring a JWT, provider, or trust. Used for expression authoring.
     *
     * @generated from protobuf rpc: TestCEL
     */
    testCEL(input: WorkloadFederationServiceTestCELRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceTestCELRequest, WorkloadFederationServiceTestCELResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceTestCELRequest, WorkloadFederationServiceTestCELResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * SearchTrusts searches trusts across all service principals with optional filters.
     * Used by the admin providers page to list trusts referencing a provider.
     *
     * @generated from protobuf rpc: SearchTrusts
     */
    searchTrusts(input: WorkloadFederationServiceSearchTrustsRequest, options?: RpcOptions): UnaryCall<WorkloadFederationServiceSearchTrustsRequest, WorkloadFederationServiceSearchTrustsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<WorkloadFederationServiceSearchTrustsRequest, WorkloadFederationServiceSearchTrustsResponse>("unary", this._transport, method, opt, input);
    }
}
